export const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
  BODY_CHANGE: "body-change",
  INPUT_CHANGE: "input-change",
  OUTPUT_CHANGE: "output-change",
  LANGUAGE_CHANGE: "langauge-change",
  SYNC_CODE: "sync-code",
  SYNC_MESSAGE: "sync-message",
  SAVE: "save",
  STOP_SAVING: "stop-saving",
  START_SAVING: "start-saving",
  SAVED: "saved",
  RUN: "run",
  START_RUNNING: "start-running",
  STOP_RUNNING: "stop-running",
  RUNNED: "runned",
  LEAVE: "leave",
  SEND_MESSAGE: "send-message",
  RECEIVE_MESSAGE: "receice-message",
  TYPING: "typing",
  TYPED: "typed",
  HTML_CHANGE: "html-change",
  CSS_CHANGE: "css-change",
  JS_CHANGE: "js-change",
  CODE_CHANGE: "code-change",
};
